import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import axiosService from 'utils/axios';
import LoadingSpinner from 'components/Shared/LoadingSpinner/LoadingSpinner';
import SearchBar from 'components/SearchBar/SearchBar';
import CardsView from 'components/Shared/CardsView/CardsView';
import ActionButton from 'components/Shared/Buttons/ActionButton';
import DestinationCard from './DestinationCard';
import { destinationCardStyles } from './styles';
import AddOrEditDestination from './AddOrEditDestination';

export default function DestinationsList() {
  const [isLoading, setIsLoading] = useState(false);
  const [destinations, setDestinations] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [addNewDestinationModalOpen, setAddNewDestinationModalOpen] = useState(false);

  const getDestinations = useCallback(() => {
    setIsLoading(true);
    axiosService
      .get(`/entities/destination/?search=${searchText}`)
      .then(res => {
        setDestinations(res.data);
      })
      .finally(() => setIsLoading(false));
  }, [searchText]);

  const onNewDestinationModalClose = () => {
    getDestinations();
    setAddNewDestinationModalOpen(false);
  };

  useEffect(() => {
    // Fetch destinations on mount
    getDestinations();
  }, [getDestinations]);

  return (
    <>
      <SearchBar label="Search a destination..." setQuery={setSearchText} />
      <div style={destinationCardStyles.actionsContainer}>
        <ActionButton type="add" onClick={() => setAddNewDestinationModalOpen(true)}>
          Destination
        </ActionButton>
      </div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <CardsView
            data={destinations}
            emptyMessage="No destinations found."
            // @ts-ignore
            CardComponent={DestinationCard}
            onDestinationDelete={getDestinations}
            onDestinationUpdate={getDestinations}
          />
          <AddOrEditDestination
            onSave={onNewDestinationModalClose}
            modalTitle="Add new destination"
            isModalOpen={addNewDestinationModalOpen}
            setModalOpen={setAddNewDestinationModalOpen}
          />
        </>
      )}
    </>
  );
}
